






















































import moment from "moment";
import {Component, Prop, Vue} from "vue-property-decorator";
import KInput from "../components/KInput.vue";
import {Settings as SettingsObj} from "../models/Settings";
import {MINUTES} from "../utils";
import AdminNav from "../components/AdminNav.vue";
import TopNav from "../components/TopNav.vue";
import {verifyAuth} from "../session";

@Component({
    components: {KInput, AdminNav, TopNav},
})
export default class Settings extends Vue {
    protected settings: SettingsObj = new SettingsObj();

    public created() {
        verifyAuth();
    }

    protected onBackClicked(evt: MouseEvent) {
        window.location.pathname = "/";
    }

    protected onSaveClicked(evt: MouseEvent) {
        this.settings.save();
    }

    get firstTee(): string {
        return this.settings.firstTee.format("H:mm");
    }

    set firstTee(val: string) {
        this.settings.firstTee = moment(val, "H:mm");
    }

    get lastTee(): string {
        return this.settings.lastTee.format("H:mm");
    }

    set lastTee(val: string) {
        this.settings.lastTee = moment(val, "H:mm");
    }

    get cooldown(): string {
        return this.settings.cooldown.asMinutes().toString();
    }

    set cooldown(val: string) {
        const cdm = parseInt(val, 10);
        this.settings.cooldown = moment.duration(cdm, MINUTES);
    }

    get granularity(): string {
        return this.settings.granularity.asMinutes().toString();
    }

    set granularity(val: string) {
        const gdm = parseInt(val, 10);
        this.settings.granularity = moment.duration(gdm, MINUTES);
    }

    get authStale(): string {
        return this.settings.authStale.asMinutes().toString();
    }

    set authStale(val: string) {
        const gdm = parseInt(val, 10);
        this.settings.authStale = moment.duration(gdm, MINUTES);
    }

    get authExpires(): string {
        return this.settings.authExpires.asMinutes().toString();
    }

    set authExpires(val: string) {
        const gdm = parseInt(val, 10);
        this.settings.authExpires = moment.duration(gdm, MINUTES);
    }
}
